<div class="row m-1">
  @for (file of Files(); track file) {
    @if (!file?.isDeleted) {
      <div class="row mb-2 align-items-center" data-testid="file-row">
        <div class="col-sm-3">
          @if (previewSrc(file?.filePayload); as src) {
            <img [src]="src" class="img-fluid" alt="" />
          } @else {
            <fa-icon [icon]="faFile" size="2x"></fa-icon>
          }
        </div>
        <div class="col-sm-1">
          <button type="button" class="btn btn-light" (click)="removeFile(file)" data-testid="file-remove-button" i18n-title title="Entfernen">
            <fa-icon [icon]="faTrashAlt"></fa-icon>
          </button>
        </div>
        @if (showDownload() && file?.filePayload?.id) {
          <div class="col-sm-1">
            <button type="button" class="btn btn-light" (click)="downloadFile(file)" data-testid="file-download-button" i18n-title title="Herunterladen">
              <fa-icon [icon]="faDownload"></fa-icon>
            </button>
          </div>
        }
        <div class="col">
          <div data-testid="file-name">{{ file?.filePayload?.originalFileName }}</div>
        </div>
      </div>
    }
  }
</div>

<div class="row">
  <div class="col-sm-10">
    <kendo-fileselect
      data-testid="file-select"
      [showFileList]="false"
      [multiple]="false"
      (select)="selectImageEventHandler($event)"
      (remove)="removeImageEventHandler($event)"
      >
      <!-- #178 slice E: kept inline on purpose. Every other Kendo text now comes from
      KendoMessagesService, but this one continues the sentence above it and differs per
      picker („Datei" here, „Bilddatei" in the profile) — one global string cannot be
      both. Everything else this file-select says comes from the service. -->
      <kendo-fileselect-messages
        i18n-dropFilesHere
        dropFilesHere="...oder Datei hier ablegen"
        i18n-select
        select="Auswählen"
        >
      </kendo-fileselect-messages>
    </kendo-fileselect>
  </div>
</div>
